import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./Service.css";
import Footer from "../../components/Footer";
import logger from "../../utils/logger";
 
import dataServicesHero from "../../assets/images/Data Services/development.avif";
import aiConsultingHero from "../../assets/images/AI Consulting services/AI Consulting Hero.avif";
import erpServicesHero from "../../assets/images/ERP Services/Oracle ERP Services.avif";
import technoFinancialHero from "../../assets/images/Techno Financial Services/Business-and-Plant-Valuations.avif";
import cyberSecurityHero from "../../assets/images/Cyber Security/breach-simulation.avif";
import trainingHero from "../../assets/images/Training/Training.webp";
import dataCenterImg from "../../assets/Products/Services/Data center.jpg";
import integratedITImg from "../../assets/Products/Services/Integrated IT.webp";
import aiInfrastructureImg from "../../assets/Products/Services/AI Infrastruture.webp";
import workforceManagementImg from "../../assets/Products/Services/Workforce Management.jpg";
 
const servicesList = [
  {
    title: "Data Services",
    route: "https://vardaands.com/",
    image: dataServicesHero,
    description:
      "Complete data lifecycle management including integration, governance, and advanced analytics capabilities."
  },
  {
    title: "AI Consulting Services",
    route: "https://exaliotech.com/",
    image: aiConsultingHero,
    description:
      "Strategy, design, and deployment of measurable AI solutions that unlock automation and ROI."
  },
  {
    title: "ERP – Oracle Services",
    route: "https://infodriveanalytics.com/",
    image: erpServicesHero,
    description:
      "Modernize Oracle ERP Cloud and on-prem ecosystems with proven implementation and managed pods."
  },
  {
    title: "Techno-Financial Services",
    route: "https://vardaanresources.com/",
    image: technoFinancialHero,
    description:
      "Engineering-led advisory that blends product innovation, investment insights, and digital execution."
  },
  {
    title: "Cybersecurity Services",
    route: "https://www.vardaan-cyber.com/",
    image: cyberSecurityHero,
    description:
      "Red teaming, vCISO, and incident response programs that secure mission-critical operations."
  },
  {
    title: "Training",
    route: "https://www.vardaan-cyber.com/professional-training",
    image: trainingHero,
    description:
      "Role-ready learning paths and certifications across cyber, data, and intelligent automation."
  },
  {
    title: "Data Centre Colocation & Hardware",
    route: null,
    image: dataCenterImg,
    description:
      "Colocation, hardware sourcing & 24/7 managed operations across APAC data-centre partners."
  },
  {
    title: "Integrated IT, DC Field Services & ITAD",
    route: null,
    image: integratedITImg,
    description:
      "Desktop to data centre — service desk, remote & smart hands, rack & stack, secure ITAD."
  },
  {
    title: "AI Infrastructure & GPUaaS",
    route: null,
    image: aiInfrastructureImg,
    description:
      "On-demand NVIDIA & AMD GPU compute for training, fine-tuning & inference."
  },
  {
    title: "Workforce Management & Staff Augmentation",
    route: null,
    image: workforceManagementImg,
    description:
      "Vetted specialist talent, managed delivery teams & workforce governance."
  }
];
 
const Service = () => {
  const history = useHistory();

  // Preload all service images immediately when component mounts for instant display
  useEffect(() => {
    // Images are already preloaded by global preloader, but ensure they're ready here too
    servicesList.forEach((service) => {
      if (service.image) {
        const img = new Image();
        // Set high fetch priority for faster loading
        if ('fetchPriority' in img) {
          img.fetchPriority = 'high';
        }
        img.src = service.image;
        // Use decode API for better performance
        if (img.decode) {
          img.decode().catch(() => {});
        }
      }
    });
  }, []);

  const handleServiceClick = (route) => {
    // All routes are external URLs - open in new tab
    if (route && (route.startsWith('http://') || route.startsWith('https://'))) {
      window.open(route, '_blank', 'noopener,noreferrer');
    } else {
      logger.warn('Invalid route:', route);
    }
  };

  const handleCardClick = (route) => {
    // Cards without a "View More" link navigate to the Contact Us page
    if (!route) {
      history.push('/contact');
    }
  };
 
  return (
    <div className="global-services-page">
      <main>
        <section className="global-services-grid" aria-label="Service categories">
          {servicesList.map((service) => (
            <div key={service.title} className="global-service-card-wrapper">
              <div
                className="global-service-card"
                aria-label={`Explore ${service.title}`}
                onClick={() => handleCardClick(service.route)}
              >
                <div className="global-service-card-face global-service-card-front">
                  <div className="global-service-card-image-container">
                    <img
                      src={service.image}
                      alt={`${service.title} hero`}
                      className="global-service-card-image"
                      loading="eager"
                      fetchPriority="high"
                      decoding="async"
                      onError={(e) => {
                        logger.error(`Failed to load image for ${service.title}:`, service.image);
                        e.target.style.display = 'none';
                      }}
                    />
                    <div className="global-service-card-overlay"></div>
                  </div>
                  <div className="global-service-card-content">
                    <h3>{service.title}</h3>
                  </div>
                </div>
                <div className="global-service-card-face global-service-card-back">
                  <div className="global-service-card-back-content">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    {service.route ? (
                      <span
                        className="global-service-view-more"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          handleServiceClick(service.route);
                        }}
                        role="button"
                        tabIndex={0}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleServiceClick(service.route);
                          }
                        }}
                      >
                        View More →
                      </span>
                    ) : (
                      <span
                        className="global-service-view-more"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          history.push('/contact');
                        }}
                        role="button"
                        tabIndex={0}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            history.push('/contact');
                          }
                        }}
                      >
                        Learn more →
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </section>
      </main>
      <Footer />
    </div>
  );
};
 
export default Service;